// @TODO: move this list to backend
const trainingTypeOptions = [
  {
    id: 1,
    title: 'webinar',
    courseType: 'webinar',
    title_hy: 'Վեբինար/սեմինար',
    title_ru: 'Вебинар/семинар',
    title_en: 'Webinar/seminar',
    title_de: 'Webinar/seminar',
  },
  {
    id: 2,
    title: 'course',
    courseType: 'course',
    title_hy: 'Դասընթաց/վորքշոփ',
    title_ru: 'Курс/Воркшоп',
    title_en: 'Course/workshop',
    title_de: 'Kurs',
  },
  {
    id: 3,
    title: 'ELearning',
    courseType: 'eLearning',
    title_hy: 'Էլեկտրոնային ռեսուրս',
    title_ru: 'E-Learning материал',
    title_en: 'E-learning material',
    title_de: 'E-Learning-Inhalte',
  },
];

export { trainingTypeOptions };
